import { ToolBarStandardButton, ToolBarStandardButtonType } from "../../core/components/toolBar";
import { Config } from "../../core/config/config";
import { Grid } from "../../core/components/grid";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import EditMainGroup, { EditMainGroupProps } from "./EditMainGroup";
import EditGroup, { EditGroupProps } from "./EditGroup";
import { General } from "../../../siteManagement/general";
import { SheetEventType } from "../../../siteManagement/sheet";
import { Helper } from "../../core/util/helper";
import { ContextGeneralSettingsApp } from "../generalSettings";
import { Metadata } from "../../core/components/commonApp";
import React from "react";
export default class EditGeneralGroupGrid extends React.Component<EditGroupGridProps, EditGroupGridState> {
    private _context: string = null;
    constructor(props) {
        super(props);
        this._context = props.field.customProps.context;
        this.state = { gridData: [], currentKey: null};        
    }

    private _getGridData = () => {
        const url = "GeneralSettings/GetGridData?context=" + this._context;
        HTTPService.get<JsonResultClass>(url)
            .then(result => {
                if (result.Code == 0) {
                    this.setState({ gridData: result.Data });
                }
            });
    }

    private _openEditMainGroup = (dataItem: data = null) => {
        let entityURL = "MainGroup/GetMainGroup";
        if (dataItem != null) {
            entityURL += "/?OGrNr=" + dataItem.key;
        }

        HTTPService.chainBatch
            .add<JsonResultClass>(entityURL)
            .add<Metadata>(Helper.getMetaData("mainGroup"))
            .promise()
            .then(result => {
                const entity = result[0];
                const metadata = result[1];
                this._initMainGroupWindow(entity.Data, metadata);
            });
    }

    private _initMainGroupWindow = (entity: any, metaData:any) => {
        const props: EditMainGroupProps = {
            dataSources: {},
            metadata: metaData as Metadata,
            entity: entity,
            isWindow: true,
            context: {},
            title: "",
            allowTravelDistanceActive: this.props.entity.ServiceReportSettings.AllowTravelDistance
        }
        const sheet = General.Sheet.Manager.createSheet();
        sheet.bind(SheetEventType.Close, (target) => {
            this._getGridData();
            $(window).trigger("ReloadLanguages", { update: true });     
        });

        sheet.show(() => {
            sheet.mountContent(EditMainGroup, props);
        });
    }

    private _openEditGroup = (dataItem: data = null) => {
        let entityURL = "Group/GetGroup";
        if (dataItem != null) {
            entityURL += "/?GrNr=" + dataItem.key;
        }

        HTTPService.chainBatch
            .add<JsonResultClass>(entityURL)
            .add<Metadata>(Helper.getMetaData("group"))
            .promise()
            .then(result => {
                const entity = result[0];
                const metadata = result[1];
                this._initGroupWindow(entity.Data, metadata);

            });
    }

    private _initGroupWindow = (entity: any, metaData: any) => {
        const props: EditGroupProps = {
            dataSources: {}, metadata: metaData as Metadata, entity: entity, isWindow: true, context: { contextType : "group"}, title: ""
        }
        const sheet = General.Sheet.Manager.createSheet();
        sheet.bind(SheetEventType.Close, (target) => {
            this._getGridData();            
        });

        sheet.show(() => {
            sheet.mountContent(EditGroup, props);
        });
    }

    private _handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: data) => {
        if (type == ToolBarStandardButtonType.NEW) {
            switch (this._context) {
                case ("maingroups"):
                    this._openEditMainGroup();
                    break;
                case ("groups"):
                    this._openEditGroup();
                    break;
            }            
        }
        else if (type == ToolBarStandardButtonType.EDIT) {
            switch (this._context) {
                case ("maingroups"):
                    this._openEditMainGroup(dataItem);
                    break;
                case ("groups"):
                    this._openEditGroup(dataItem);
                    break;
            }                 
        }
    }

    private _createGrid = () => {
        const standardButtons: Array<ToolBarStandardButton> = [];
        standardButtons.push({ type: ToolBarStandardButtonType.NEW, caption: Config.translations.newLabel, enabled: true });
        standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: Config.translations.editLabel, enabled: true });

        let grid = (
            <Grid data={this.state.gridData} options={this.props.context.editGroupGridOptions} id={"groupGrid_" + this._context}
                standardButtons={standardButtons} onClickStandardButton={this._handleClickStandardButton}  />
            );
        return(grid)
    }

    componentDidMount() {
        this._getGridData();
    }

    render() {
        const grid = this._createGrid();
        return (
            <div style={{ height: "100%", width: "100%" }}>
                <div className="flex-container flex-container__item" style={{ height: "300px" }}>
                    {grid}
                </div>
            </div>);
            
    }
};

interface EditGroupGridProps {
    context: ContextGeneralSettingsApp;
    entity: any;
}

interface EditGroupGridState {
    gridData: data[];
    currentKey: number;
}

interface data {
    key: number;
    value: string;
}